module.exports = __webpack_public_path__ + "img/logo-wpp.e34b71f3.svg";